import { useState, useEffect } from 'react';
import { alertManager } from '../utils/alertManager';
import { AlertData } from '../components/base/Alert';

export const useAlert = () => {
    const [alerts, setAlerts] = useState<AlertData[]>([]);

    useEffect(() => {
        // Подписываемся на изменения алертов
        const unsubscribe = alertManager.subscribe((newAlerts) => {
            setAlerts(newAlerts);
        });

        // Получаем текущие алерты
        setAlerts(alertManager.getAlerts());

        // Отписываемся при размонтировании
        return unsubscribe;
    }, []);

    const hideAlert = (id?: string) => {
        alertManager.hide(id);
    };

    return {
        alerts,
        hideAlert,
        // Экспортируем методы менеджера для удобства
        show: alertManager.show.bind(alertManager),
        success: alertManager.success.bind(alertManager),
        error: alertManager.error.bind(alertManager),
        warning: alertManager.warning.bind(alertManager),
        info: alertManager.info.bind(alertManager),
        // Методы для управления конфигурацией
        setDefaultConfig: alertManager.setDefaultConfig.bind(alertManager),
        getDefaultConfig: alertManager.getDefaultConfig.bind(alertManager),
    };
};
